import comp from "./SectionFeed";
export default comp;
